/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowBendDownLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M232,56A104.11791,104.11791,0,0,1,128,160H88v40a8.00053,8.00053,0,0,1-13.65723,5.65723l-48-48a8.00122,8.00122,0,0,1,0-11.31446l48-48A8.00065,8.00065,0,0,1,88,104v40h40a88.09957,88.09957,0,0,0,88-88,8,8,0,0,1,16,0Z" />
    </Svg>
  );
}

export default ArrowBendDownLeft;
